import { useState } from "react";
import LoginModal from "@/components/LoginModal";

export default function LoginButton({ className = "", label = "Sign in" }) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        data-testid="login-open-btn"
        onClick={() => setOpen(true)}
        className={`inline-flex items-center gap-2 rounded-full px-5 py-2 font-mono-tech text-[11px] tracking-[0.3em] uppercase whitespace-nowrap transition-colors border border-black/20 hover:bg-[color:var(--np-text)] hover:text-[color:var(--np-bg)] ${className}`}
      >
        <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--np-live)] animate-pulse" />
        {label}
      </button>
      <LoginModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
